<!--<lib-buy-btn [id]="product.id"></lib-buy-btn>-->
<ng-template libCustomHost></ng-template>
